export default __webpack_public_path__ + "static/media/Coperion.05601040.png";